// JavaScript Document
function AdjustPadding(){
    var lWH = $(window).height();  
    var lH = $("header.site-header").height();
    var lF = $("#shopify-section-footerSt").height();
    var lS = lWH - (lH + lF + 220);
    var lM = $("main").height()-lS;
    if(lM < 0){
        $("main").css("height",lS + "px");
    }
}